'use client'

import styles from './Error.module.scss'
import { getAppConfig } from '@/config/config'
import { Link } from '@/components/Link'
import Button from '@/components/Button/Button'

const config = getAppConfig()

const Error = ({ statusCode }: { statusCode: number }) => {
  let statusText =
    'Diese Seite existiert nicht (mehr). Vielleicht wurde sie gelöscht umbenannt oder nie veröffentlicht.'
  if (statusCode !== 404) {
    statusText = 'Da ist etwas schiefgelaufen. Wir arbeiten daran - versuchs gleich nochmal!'
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>UPS!</h1>
        <p className={styles.text}>{statusText}</p>
        <div className={styles['btn-container']}>
          {statusCode !== 404 && (
            <Button className={styles.link} onClick={() => location.reload()}>
              Seite neu laden
            </Button>
          )}
          <Link href={`${config.basePath}/`} className={styles.link}>
            Zur Startseite
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Error
